import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import MonthPickerInput from 'react-month-picker-calendar';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class MonthlyCalledJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            selectedCustomerId: null,
            selectedCustomer: null,
            calledJobs:[],
            totalJobs:null,
            totalAbortedJobs:null,
            url:'/api/v1/portal/portal-admin/monthly-total-called-jobs-report/',
            downloadReportName: 'Total Called jobs Report.xlsx',
            yearSelection:moment().year(),
            monthSelection:moment().month()+1,
        };
    }
    buildMonthOptions() {
        var arr = [];
        for (let i = 1; i <= 12; i++) {
        arr.push(<option key={i} value={i}>{moment(i, 'MM').format('MMM')}</option>)
        }
        return arr; 
    }
    buildYearOptions() {
        var arr = [];
        for (let i = 1; i <= 5; i++) {
            let nyear = moment().add(i, 'years').format('YYYY');
            arr.push(<option key={i+nyear} value={nyear}>{nyear}</option>)
        }
        return arr; 
    }
    buildPrevYearOptions() {
        var arr = [];
        for (let i = 5; i >= 1; i--) {
            let pyear = moment().subtract(i, 'years').format('YYYY');
            arr.push(<option key={i+pyear} value={pyear}>{pyear}</option>)
        }
        return arr; 
    }
    handleMonthChange(e){
        this.setState({monthSelection:e.target.value});
    }
    handleYearChange(e){
        this.setState({yearSelection:e.target.value});
    }
    handleMonthlyTotalCalledJobsReportGeneration(e) {
        let url = this.state.url+this.state.monthSelection+'-'+this.state.yearSelection;
        this.setState({isLoading: true});
        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((res) => {
            this.setState({calledJobs:res.jobs});
            this.setState({isLoading: false});
          });
        });
    }
   
      handleJobReportGeneration(filename) {
        filename =   'Total Called jobs '+moment(this.state.monthSelection, 'MM').format('MMM')+' '+this.state.yearSelection+' Report.xlsx';
        if(this.state.monthSelection){
            let url = "/api/v1/portal/finance/monthly-total-called-job-report/"+this.state.monthSelection+'-'+this.state.yearSelection;
            return fetch(url,{
                method: "GET",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json',
                'Content-Type': 'multipart/form-data'
                }
            }
            ).then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); 
                a.click();    
                a.remove(); 
            }).catch(err=>{
            alert('sorry something went wrong.') ;
            });
        }
      }
    // handleMonthYearGeneration(maskedValue, selectedYear, selectedMonth){
    //     this.setState({
    //         yearSelection: selectedYear,
    //         monthSelection: selectedMonth,
    //         displayMonthSelection: moment(selectedMonth,"MM").format("MMMM"),
            
    //     });
    // }
    handleUserClick(event){
        let userid = event.target.getAttribute('data-tag');
        let username = event.target.innerHTML;
        if(userid){
            $('#infomodallabel').html(username+'"s called Job Lists');
            $('#infomodal .modal-body').html(<i className="fa fa-spinner fa-pulse"></i>);
            $('#infomodal').modal();
            let url ='/api/v1/portal/portal-admin/monthly-total-called-jobs-by-user/'+this.state.monthSelection+'-'+this.state.yearSelection+'/'+userid;
            return fetch(url, {
              method: "GET",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
              },
            }).then((responseText) => {
              let response = responseText.json();
              response.then((res) => {
                let outputs = res.jobIds;
                let setModalOutput = Object.keys(outputs).map((key)=> {
                    return '<tr><td><a target="_blank" href="/jobs/view/'+outputs[key]+'">'+outputs[key]+'</a></td></tr>';
                });
                
                let setModalOutputTotable = '<table class="showCalledJobsListTBL text-center">\n\
                            <thead>\n\
                                <th>CALLED JOBS</th>\n\
                            </thead>\n\
                            <tbody>'+setModalOutput+'</tbody>\n\
                        </table>';

                setModalOutputTotable =  setModalOutputTotable.replace(/\,/g,"");
                $('#infomodal .modal-body').html(setModalOutputTotable);
                //$('#infomodal').modal();
              });
            }).catch(()=>{
                $('#infomodal .modal-body').html('Something went wrong.');
            });
        }
    }
    render() {
        let totalJobs = 0;
        let totalUsers = (this.state.calledJobs.length > 0 ? this.state.calledJobs.length -1 : this.state.calledJobs.length);

        let jobsData = [];
        let tableHeaders = [];
        let list = [];
        if(this.state.calledJobs.length > 0){
            let headers = this.state.calledJobs[0];
            Object.keys(headers).forEach(function(key) {
                if(key == 'userid' || key == 'called_jobs'){
                    return;
                }else if(key == 'full_name'){
                    tableHeaders.push(<th>USER</th>);
                }else{
                    tableHeaders.push(<th>{moment(key).format('DD/MM/YYYY')}</th>);
                } 
            });
          
            jobsData = this.state.calledJobs.map(crow =>{
                return (
                    <tr key={crow.userID}>
                        {Object.keys(crow).filter(k => k !== 'userID').map(k => {
                            if(k == 'userid' || k == 'called_jobs'){
                                return;
                            }else{
                                if(k == 'full_name'){
                                    return (
                                        <td key={crow.userID+'-'+k}><a title="Click to view called jobs" className="user-click-event" data-tag={crow.userid} onClick={(e) => this.handleUserClick(e)}>{crow[k]}</a></td>
                                    );
                                }else{
                                    return (
                                        <td key={crow.userID+'-'+k}>{crow[k]}</td>
                                    );
                                }
                            }
                        })}
                    </tr>
                );
            });
            let lastRow = this.state.calledJobs.slice(-1).pop();
            
            Object.keys(lastRow).forEach(function(key) {
                if(key == 'full_name'  || key == 'called_jobs'){return;}
                totalJobs += (!lastRow[key]) ? 0 : parseInt(lastRow[key]);
            });
        }else{
            jobsData.push(
               <tr key='no-records'><td className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Monthly Called Jobs Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    
                    <div className="col-md-2">
                        <div className="form-group month_picker">
                            <label><h3>Select Month:</h3></label>
                            <select className="form-control" id="months" defaultValue={this.state.monthSelection} onChange={(e)=>this.handleMonthChange(e)}>
                                {this.buildMonthOptions()}
                            </select>
                            {/* <label><h3>Select Month & Year</h3></label><br/> */}
                            {/* <MonthPickerInput
                              onChange={(maskedValue, selectedYear, selectedMonth) =>
                                this.handleMonthYearGeneration(maskedValue, selectedYear, selectedMonth+1)
                              }
                            /> */}
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label><h3>Select Year:</h3></label>
                            <select className="form-control" id="years" defaultValue={this.state.yearSelection} onChange={(e)=>this.handleYearChange(e)}>
                                {this.buildPrevYearOptions()}
                                <option key={moment().year()} value={moment().year()}>{moment().year()}</option>
                                {this.buildYearOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success daily-delivered-btn-margin" onClick={(e) => this.handleMonthlyTotalCalledJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate {moment(this.state.monthSelection, 'MM').format('MMM')} {this.state.yearSelection} Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg daily-delivered-btn-margin"
                                    onClick={(e) => {
                                    this.handleJobReportGeneration(this.state.downloadReportName);
                                  }}>
                                <i className="fa fa-download"></i> Download {moment(this.state.monthSelection, 'MM').format('MMM')} {this.state.yearSelection}  Report
                            </button>
                        </div>
                    </div>
                    
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <h4 className="alert alert-info">Total User who called for the month {moment(this.state.monthSelection, 'MM').format('MMM')} : <b>{totalUsers}</b></h4>
                    </div>
                    <div className="col-md-4">
                        <h4 className="alert alert-info">Total Jobs called for the month {moment(this.state.monthSelection, 'MM').format('MMM')} : <b>{totalJobs}</b></h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-9 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                            <thead>
                                   <tr>{tableHeaders}</tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="6"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    jobsData
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-monthly_called_jobs_report')) {
    ReactDOM.render(
        <MonthlyCalledJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-monthly_called_jobs_report')
    );
}
